module.exports = __webpack_public_path__ + "img/beijing-4.d36fef9f.jpg";